import { Row, Image } from 'antd';
import { useEffect, useState } from 'react';
import VIDEOS from 'src/commons/variables/videos'
import ICONS from 'src/commons/variables/icons';
import Header from 'src/components/Header'
import styled from 'styled-components'
import Footer from 'src/components/Footer';
import WithApp from 'src/components/WithApp';
import { withAppDummys } from 'src/commons/dummys';
import STYLES from 'src/commons/variables/style'
import './App.css';

const MainWrapper = styled.div`
video{
  width: 100%;
}
.withapp-intro{
  @media (max-width: 1440px) {    
    width: 1000px;
    margin: 0 auto;        
    } 
    @media (max-width: 1000px) {    
    width: 100%;
    }   
}
.title{
  padding-top: 105px;
  padding-bottom: 105px;
  font-size: 45px;
  font-weight: bold;  
  color: ${STYLES.GREEN}; 
}

@media (max-width: 573px) {  
  .title{  
        font-size: 24px !important;  
        padding-top: 59px;
        padding-bottom: 59px;
      }
    } 

@media (min-width: 800px) {  
    .blog-button{
          display: none;
        }  
    } 
`
const ButtonWrapper = styled.div`
  position: fixed;
  display:flex;
  font-family: Noto Sans CJK KR;
  justify-content: center;
  align-items: center;
  font-weight: "bold";
  font-size: 20px;
  z-index: 1;
  bottom: 0;
  width: 100%;
  height: 74px;
  background-color:${STYLES.BLUE} ;  
  
  a {
  text-decoration: none !important;
  font-weight: "bold";
  font-size: 20px;
  color: white;
  }

  @media (min-width: 573px) {            
    display: none;     
    }
`

function App() {
  const [link, setlink] = useState("")
  const [isMobile, setisMobile] = useState(false)

  useEffect(() => {
    const isMobileReg = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent)
    const isApple = /iPhone|iPad|iPod/i.test(window.navigator.userAgent)
    const isAndroid = /Android/i.test(window.navigator.userAgent)
    isMobileReg && setisMobile(true)
    if (isAndroid) {
      setlink("https://play.google.com/store/apps/details?id=io.projectwith.with_flutter")
      return
    } else if (isApple) {
      setlink("https://apps.apple.com/kr/app/위드-project-with/id1484254608")
      return
    }
    return () => {
    }
  }, [])

  return (
    <>
      <ButtonWrapper>
        <a href={link}>
          앱 다운로드 하기
        </a>
      </ButtonWrapper>

      <div className="App">
        <Header />
        <MainWrapper>
          <a className="blog-button" target="_blank" href="https://www.instagram.com/projectwith_official">
            <div style={{
              width: "74px",
              height: "74px",
              position: "fixed",
              bottom: 165,
              right: 11,
              zIndex: 1,
              opacity: 1
            }}>
              <Image preview={false} src={ICONS.INSTAGRAM.default} />
            </div>
          </a>

          <a className="blog-button" target="_blank" href="https://blog.naver.com/projectwith">
            <div style={{

              width: "64px",
              height: "64px",
              position: "fixed",
              bottom: 90,
              right: 16,
              zIndex: 1,
              opacity: 1
            }}>
              <Image preview={false} src={ICONS.BLOG.default} />
            </div>
          </a>

          {isMobile &&
            <section className="mobile-main">
              <video
                autoPlay
                muted
                loop
                playsInline
              >
                <source src={isMobile ? VIDEOS.MAIN_MOBILE.default : VIDEOS.MAIN_PC.default} type="video/mp4" />
              </video>
            </section>
          }
          {isMobile == false &&
            <section className="pc-main">
              <video
                autoPlay
                muted
                loop
                playsInline
              >
                <source src={isMobile ? VIDEOS.MAIN_MOBILE.default : VIDEOS.MAIN_PC.default} type="video/mp4" />
              </video>
            </section>
          }

          <section >
            <Row className="title" justify="center" >
              We Identify The Hidden
            </Row>
          </section>

          <section className="withapp-intro" >
            <Row justify={"center"}   >
              {withAppDummys.map(data => {
                return <WithApp key={data.id} title={data.title} icon={data.icon} description={data.description} image={data.image} />
              })}
            </Row>
          </section>
        </MainWrapper>

        <Footer />
      </div >
    </>
  );
}

export default App;
